import * as React from 'react';

import ApiKeyContext from "../../../../contexts/ApiKeyContext.js";
import SaleReport from "./SaleReport.js";
import SaleReportConversationBody from "./SaleReportConversationBody.js";
import SaleReportCommentComposer from "./SaleReportCommentComposer.js";
import SaleReportConversationHeader from "./SaleReportConversationHeader.js";
import LoadMask from "../../../../components/LoadMask.js";
import "./SaleReportConversationPanel.scss";

export default function SaleReportConversationPanel({ saleReportId, onChange }) {
	const API_KEY_CONTEXT = React.useContext(ApiKeyContext);

	const [saleReport, setSaleReport] = React.useState(false);
	const [ts, setTs] = React.useState(false);

	const getSaleReport = React.useCallback(async () => {
		const sale_report = await SaleReport.Load(API_KEY_CONTEXT, saleReportId);
		setSaleReport(sale_report);
	}, []);
	React.useEffect(() => {
		getSaleReport();
	}, []);

	const triggerUpdate = () => {
		setTimeout(() => setTs(Date.now()), 250);
		onChange && onChange();
	};

	return (
		<div id="sale-report-conversation">
			<SaleReportConversationHeader saleReportId={saleReportId} ts={ts} />
			<SaleReportConversationBody saleReportId={saleReportId} ts={ts} />
			{saleReport?.id && (<SaleReportCommentComposer saleReport={saleReport} onSubmit={triggerUpdate} />)}
			<LoadMask show={!saleReport?.id} />
		</div>
	);
}